import { render, staticRenderFns } from "./RestrictedSocialDateModal.vue?vue&type=template&id=49bca99a&"
import script from "./RestrictedSocialDateModal.vue?vue&type=script&lang=js&"
export * from "./RestrictedSocialDateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports